import { useState } from "react";
import { toast } from "sonner";
import { Panel, Chip, Th, Td } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, errMsg, fmt, gbp, pnlClass, ldnTime, cur } from "@/lib/api";

function StopEditor({ t, onDone }) {
  const [v, setV] = useState(String(t.stop));
  const save = async () => {
    try {
      await api.put(`/levels/trades/${t.id}/stop`, { stop: Number(v) });
      toast.success("Stop updated");
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="flex items-center gap-1">
      <Input data-testid={`trade-stop-input-${t.id}`} value={v} onChange={(e) => setV(e.target.value)} className="num h-8 w-24 bg-slate-950 text-xs" />
      <Button data-testid={`trade-stop-save-${t.id}`} size="sm" variant="secondary" className="h-8" onClick={save}>Set</Button>
    </div>
  );
}

export function ActiveTrades({ trades, onChange }) {
  const close = async (id) => {
    try {
      await api.post(`/levels/trades/${id}/close`);
      toast.success("Trade closed");
      onChange();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <Panel title="Active trades" testid="levels-active-trades">
      {!trades?.length ? (
        <p className="text-sm text-slate-500" data-testid="levels-no-active-trades">No open trades right now.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full min-w-[900px]">
            <thead className="border-b border-slate-800"><tr><Th>Market</Th><Th>Leg</Th><Th>Side</Th><Th>Size</Th><Th>Entry</Th><Th>Now</Th><Th>Target</Th><Th>Stop</Th><Th>Points</Th><Th>P&L</Th><Th>Opened</Th><Th>Live</Th><Th /></tr></thead>
            <tbody>
              {trades.map((t) => (
                <tr key={t.id} data-testid={`active-trade-${t.id}`} className="border-b border-slate-800/60">
                  <Td>{t.name}</Td>
                  <Td><Chip status={t.leg === "reversal" ? "IN_REVERSAL" : "IN_INITIAL_TRADE"} label={t.leg} /></Td>
                  <Td><Chip status={t.direction > 0 ? "LONG" : "SHORT"} label={t.direction > 0 ? "Long" : "Short"} /></Td>
                  <Td className="num">{cur()}{fmt(t.size)}</Td>
                  <Td className="num">{fmt(t.entry)}</Td>
                  <Td className="num">{fmt(t.current)}</Td>
                  <Td className="num">{fmt(t.target)}</Td>
                  <Td><StopEditor t={t} onDone={onChange} /></Td>
                  <Td className={`num ${pnlClass(t.live_points)}`}>{fmt(t.live_points)}</Td>
                  <Td className={`num font-semibold ${pnlClass(t.live_pnl)}`}>{gbp(t.live_pnl)}</Td>
                  <Td className="text-xs text-slate-400">{ldnTime(t.opened_at)}</Td>
                  <Td>{t.live ? <Chip status={t.live.needs_review ? "WARNING" : t.live.status === "open" ? "LIVE" : "SKIPPED"} label={t.live.needs_review ? "needs review" : t.live.status} /> : <Chip status="PAPER" />}</Td>
                  <Td><Button data-testid={`active-trade-close-${t.id}`} size="sm" variant="destructive" className="h-8" onClick={() => close(t.id)}>Close</Button></Td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Panel>
  );
}
